export default function createDeviceDetailService(jokiInstance) {
    const serviceId = 'DeviceDetailService';
    const joki = jokiInstance;
    let selectedDeviceCode = null;

    let selectedDeviceData = null;

    function messageHandler(event) {
        // console.log("DeviceDetailsService:messageHandler", event);
        switch (event.key) {
            case 'selectDevice':
                select(event.body);
                break;
            case 'deselectDevice':
                clear();
                break;
            case 'getState':
                return selectedDeviceCode;
            case 'getDeviceData':
                updateSelectedDeviceData();
                if (selectedDeviceData !== null && selectedDeviceData.code === selectedDeviceCode) {
                    return selectedDeviceData;
                }
                return null;
            case 'logout':
                selectedDeviceCode = null;
                break;
            default:
                break;
        }
    }

    function clear() {
        selectedDeviceCode = null;
        selectedDeviceData = null;
        triggerUpdate();
        triggerDataUpdate();
        triggerServiceReset();
    }

    function select(deviceCode) {
        selectedDeviceCode = deviceCode;
        updateSelectedDeviceData();
        triggerUpdate();
    }

    function updateSelectedDeviceData() {
        // console.log("send updaet to DevicesService")
        joki.ask({
            to: 'DevicesService',
            key: 'getDevice',
            body: { code: selectedDeviceCode },
        })
            .then(results => {
                // console.log("DeviceDetailsService:getSelectedData:askThen: Results", results["DevicesService"]);
                selectedDeviceData = results.DevicesService;
                triggerDataUpdate();
            })
            .catch(err => {
                console.warn(
                    `SelectedDeviceService:updateSelectedDeviceData: Device code ${selectedDeviceCode} is unknown. It may be that no devices have been retrieved yet.`
                );
                // selectedDeviceId = null;
            });
        return selectedDeviceData;
    }

    function triggerUpdate() {
        joki.trigger({
            from: serviceId,
            serviceUpdate: true,
            body: selectedDeviceCode,
        });
    }

    function triggerDataUpdate() {
        joki.trigger({
            from: serviceId,
            key: 'selectedDeviceDataUpdated',
            body: selectedDeviceData,
        });
    }

    function triggerServiceReset() {
        joki.trigger({
            from: serviceId,
            key: 'serviceReset',
            body: selectedDeviceData,
        });
    }

    joki.addService({ id: 'DeviceDetailService', fn: messageHandler });
}
